
/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoRequestCompany {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * 
     */
    PoolId?: string;
    /**
     * 
     */
    OrderId?: string;
    /**
     * 1表示客户，2表示供应商
     */
    Type?: number;
}

/**
 * -表单校验
 */
export const DtoRequestCompanyRules = {
}
